module.exports = __webpack_public_path__ + "img/Picture2.9bae0847.png";